module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/WhyNeedSection/car-damage-ae6a7172298d8bd51d6af7001feccaf2.png";